document.addEventListener('DOMContentLoaded', function() {
    var showModal = sessionStorage.getItem('showModal');

    if(showModal === null){
        // Ne pas afficher la pop-up automatiquement
        sessionStorage.setItem('showModal', 'false');
    } else {
        // Logique pour afficher la pop-up en fonction d'une condition ou d'un événement
    }

    document.querySelector('.size-guide-trigger').addEventListener('click', function() {
        document.getElementById('size-guide-modal').style.display = 'flex';
        sessionStorage.setItem('showModal', 'true');
    });

    document.querySelector('.size-guide-close').addEventListener('click', function() {
        document.getElementById('size-guide-modal').style.display = 'none';
        sessionStorage.setItem('showModal', 'false');
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('state-guide-modal');
    const openModal = document.querySelector('.open-state-modal');
    const closeModal = document.querySelector('.state-guide-close');

    if (openModal) {
        openModal.addEventListener('click', function (e) {
            e.preventDefault();
            modal.style.display = 'block';
        });
    }

    if (closeModal) {
        closeModal.addEventListener('click', function () {
            modal.style.display = 'none';
        });
    }

    window.addEventListener('click', function (e) {
        if (e.target == modal) {
            modal.style.display = 'none';
        }
    });
});